import { createContext } from 'react';

const UserContext = createContext({
  user: null,
  setUser: null,
  removeUser: null
});

export default UserContext;
